
(function () {
  'use strict';

  const ACCESS_KEY = 'vip_access_granted';

  // Change this to your actual VIP password page URL.
  const VIP_GATE_URL = '/pages/black-friday-password';

  function checkVIPAccess() {
    let accessGranted = false;

    try {
      const savedAccess = localStorage.getItem(ACCESS_KEY);

      if (savedAccess) {
        const access = JSON.parse(savedAccess);

        if (
          access.granted === true &&
          access.expiresAt > Date.now()
        ) {
          accessGranted = true;
        } else {
          localStorage.removeItem(ACCESS_KEY);
        }
      }
    } catch (error) {
      localStorage.removeItem(ACCESS_KEY);
    }

    if (!accessGranted) {
      window.location.replace(VIP_GATE_URL);
    }
  }

  checkVIPAccess();

})();
